import { normalizeReportData } from './reportDataMerge.js';

export const SRM_THREAT_WORKFLOW = 'integrated_threat_analysis';
export const SRM_THREAT_LEASE_MS = 10 * 60 * 1000;

export const isClientSrmSetupProject = (project: any, organizationId: string, uid: string): boolean =>
    !!uid && !!project && project.organizationId === organizationId && project.userId === uid &&
    typeof project.assetId === 'string' && !!project.assetId && ['Compiling', 'Review'].includes(project.status);

export function srmThreatAnalysisInput(context: any, module: any) {
    context = { ...context.architectRequest, ...context };
    const prefill = module.prefillData || {};
    const location = prefill.location || {};
    return {
        ...prefill,
        scope: module.description || context.scope || context.summary || 'Assess threats to the operational footprint.',
        orgType: context.orgType || context.name || context.projectName || '',
        operationalFootprint: context.operationalFootprint || context.summary || '',
        assets: prefill.assets || prefill.assetInventory || context.assets || context.assetInventory || [],
        personnel: prefill.personnel || prefill.personnelRegistry || context.personnel || context.personnelRegistry || [],
        kiq: prefill.kiq || context.kiq || '',
        location_address: prefill.location_address || prefill.address || location.address || context.location_address || context.locationAddress || context.address || '',
        location_city: prefill.location_city || prefill.city || location.city || context.location_city || context.city || '',
        location_state: prefill.location_state || prefill.state || location.state || context.location_state || context.state || '',
        location_country: prefill.location_country || prefill.country || location.country || context.location_country || context.country || '',
        location_zip: prefill.location_zip || prefill.zip || location.zip || context.location_zip || context.zip || '',
    };
}

export async function generateValidatedSrmThreatReport(generate: () => Promise<any>) {
    for (let attempt = 0; attempt < 2; attempt++) {
        const report = normalizeReportData(await generate());
        const empty = report?.errorCode === 'empty_report' || (!report?.error &&
            ![report?.executiveSummary, report?.summary].some(value => typeof value === 'string' && value.trim()));
        if (empty && attempt === 0)
            continue;
        if (empty)
            throw new Error('No report content was returned for the integrated analysis after one retry.');
        if (report?.error)
            throw new Error(report.error);
        return { ...report, reportType: 'IntegratedAnalysisResult', generatedAt: new Date().toISOString() };
    }
    throw new Error('No report content was returned for the integrated analysis.');
}
